export const state = () => ({
  config: undefined
})

export const actions = {
  SET_CONFIG({ commit }, value) {
    commit('SET_CONFIG', value)
  }
}

export const mutations = {
  SET_CONFIG(state, value) {
    state.config = value
  }
}

export const getters = {
  getConfig: state => state.config,
  isRentalCenter: state => state.config !== undefined
}
